const firebaseConfig = {
    apiKey: "AIzaSyBjNkKD_p7xowGsWWlM2NYOakzmVUqeyU8",
    authDomain: "mywebsite-32a95.firebaseapp.com",
    databaseURL: "https://mywebsite-32a95.firebaseio.com",
    projectId: "mywebsite-32a95",
    storageBucket: "mywebsite-32a95.appspot.com",
    messagingSenderId: "1098914047368",
    appId: "1:1098914047368:web:0ed93acc673101efcb863d",
    measurementId: "G-QWQNJXMYVJ"
}

export default firebaseConfig;